<!-- PageFooter -->

<template>
  <div>
    <footer>
      <tabBarBirthday v-if="moduleInfo.name === 'birthday' || pathname === '/web/birthday'" :active="active">
      </tabBarBirthday>
      <TabBarBook v-else-if="moduleInfo.name === 'books'" :active="active"></TabBarBook>
      <tabBarFestival v-else-if="moduleInfo.name === 'festival'" :active="active"></tabBarFestival>
      <tabBarDrama v-else-if="moduleInfo.name === 'drama'" :active="active"></tabBarDrama>
      <tabBarLife v-else-if="moduleInfo.name === 'life'" :active="active"></tabBarLife>
      <tabBarHealth v-else-if="moduleInfo.name === 'health'" :active="active"></tabBarHealth>
      <TabBarStore v-else-if="moduleInfo.name === 'mall'" :active="active"></TabBarStore>
      <tabBarTravel v-else-if="moduleInfo.name === 'travel'" :active="active"></tabBarTravel>
      <TabBarCommon
        v-else-if="moduleInfo.name === 'vegetable' || moduleInfo.name === 'supermarket' || moduleInfo.name === 'video' || moduleInfo.name === 'privilege' || moduleInfo.name === 'birthdayPrivilege' || moduleInfo.name === 'movieOther'"
        :active="active"></TabBarCommon>
    </footer>
  </div>
</template>

<script>
import TabBarBook from "@/components/common/tabbar-books";
import TabBarBirthday from "@/components/common/tabbar-birth";
import TabBarStore from "@/components/common/tabbar";
import TabBarCommon from "@/components/common/tabbar-common.vue";

export default {
  name: "page-footer",

  components: {
    TabBarStore,
    TabBarBook,
    TabBarBirthday,
    TabBarCommon,

    tabBarDrama: () => import("@/components/common/tabbar-drama"),
    tabBarFestival: () => import("@/components/common/tabbar-festival/index"),
    tabBarLife: () => import("@/components/common/tabbar-life"),
    tabBarHealth: () => import("@/components/common/tabbar-health"),
    tabBarTravel: () => import("@/components/common/tabbar-travel"),
  },

  props: {
    active: { type: Number, default: 0 }
  },

  data() {
    return {
      moduleInfo: this.get_mall_module(),

      pathname: ''
    }
  },

  // 2024-04-10 修复 体检底部菜单未展示的问题
  mounted() {
    setTimeout(() => {
      this.moduleInfo = this.get_mall_module()
    }, 2000)

    this.pathname = location.pathname
  }
}
</script>

<style scoped></style>
